module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opus-absence text-dark"
  }, [_c('h2', {
    staticClass: "marg-1-bottom capitalize"
  }, [_vm._v("Fraværsindberetninger")]), _vm._v(" "), (_vm.isNoConfiguration) ? [_vm._m(0)] : [_c('div', {
    staticClass: "opus-absence__header"
  }, [_c('div', {
    staticClass: "opus-absence__header__left"
  }, [_c('DoDatePickerRange', {
    attrs: {
      "allowSameDate": true,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "maximumDateRange": 365
    },
    on: {
      "startChanged": _vm.startDateChanged,
      "endChanged": _vm.endDateChanged
    }
  }), _vm._v(" "), _c('Tabs', {
    attrs: {
      "tabs": _vm.tabsList,
      "selected": _vm.selectedTab
    },
    on: {
      "select": function($event) {
        _vm.selectedTab = $event
      }
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Personer',
      "tags": _vm.uniqueNames,
      "selectedTags": _vm.selectedNames,
      "numberOfSelectedTagsToShow": 2,
      "placeholder": 'Vælg personer'
    },
    on: {
      "select": _vm.toggleName,
      "clear": _vm.clearNames
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": 'Fraværstype',
      "tags": _vm.uniqueAbsenceTypes,
      "selectedTags": _vm.selectedAbsenceTypes,
      "numberOfSelectedTagsToShow": 2,
      "placeholder": 'Vælg fraværstype'
    },
    on: {
      "select": _vm.toggleAbsenceType,
      "clear": _vm.clearAbsenceTypes
    }
  })], 1), _vm._v(" "), (_vm.isOpusAbsenceActivated) ? _c('div', {
    staticClass: "opus-absence__header__right"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isShowQuotasModal = true
      }
    }
  }, [_vm._v("Vis kvoter")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "opus-absence__body"
  }, [(_vm.isLoading) ? _c('Loader') : [_c('table', {
    staticClass: "do-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th-sorter td-created",
    class: {
      'th-sorter--active': !_vm.isSortPristine && _vm.sortBy === 'vCreatedAt'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('vCreatedAt')
      }
    }
  }, [_vm._v("\n              Oprettet "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'name'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('name')
      }
    }
  }, [_vm._v("\n              Navn "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'employment_number'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('employment_number')
      }
    }
  }, [_vm._v("\n              Ansættelse "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter",
    class: {
      'th-sorter--active': _vm.sortBy === 'absence_type_text'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('absence_type_text')
      }
    }
  }, [_vm._v("\n              Fraværstype "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-date",
    class: {
      'th-sorter--active': _vm.sortBy === 'start_date'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('start_date')
      }
    }
  }, [_vm._v("\n              Startdato "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-date",
    class: {
      'th-sorter--active': _vm.sortBy === 'end_date'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('end_date')
      }
    }
  }, [_vm._v("\n              Slutdato "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-units",
    class: {
      'th-sorter--active': _vm.sortBy === 'absence_days'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('absence_days')
      }
    }
  }, [_vm._v("\n              Dage "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-units",
    class: {
      'th-sorter--active': _vm.sortBy === 'absence_hours'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('absence_hours')
      }
    }
  }, [_vm._v("\n              Timer "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), _c('th', {
    staticClass: "th-sorter td-status",
    class: {
      'th-sorter--active': !_vm.isSortPristine && _vm.sortBy === 'state'
    },
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.setSort('state')
      }
    }
  }, [_vm._v("\n              Status "), _c('span', {
    staticClass: "icon-menu-open"
  })]), _vm._v(" "), (_vm.selectedTab !== 'queued') ? _c('th', {
    staticClass: "td-error"
  }, [_vm._v("\n              Besked\n            ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "td-action"
  })])]), _vm._v(" "), _c('tbody', [(_vm.displayedAbsences.length === 0) ? _c('tr', [_c('td', {
    staticClass: "italic",
    attrs: {
      "colspan": _vm.selectedTab !== 'queued' ? 11 : 10
    }
  }, [_vm._v("\n              Ingen fraværsindberetninger fundet\n            ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayedAbsences), function(item) {
    return _c('tr', {
      key: item.id
    }, [_c('td', {
      staticClass: "td-created"
    }, [_vm._v(_vm._s(item.vCreatedAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vEmploymentNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vAbsenceTypeText))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(item.vStartDate))]), _vm._v(" "), _c('td', {
      staticClass: "td-date"
    }, [_vm._v(_vm._s(item.ongoing ? 'Åbenstående' : item.vEndDate))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(item.absence_days)))]), _vm._v(" "), _c('td', {
      staticClass: "td-units"
    }, [_vm._v(_vm._s(_vm.formatDecimal(item.absence_hours)))]), _vm._v(" "), _c('td', {
      staticClass: "td-status"
    }, [(item.state === 'error') ? _c('span', {
      staticClass: "status-pill status-pill--error"
    }, [_vm._v("Fejlet")]) : (item.state === 'queued' || !item.state) ? _c('span', {
      staticClass: "status-pill status-pill--pending"
    }, [_vm._v("Afventer")]) : (item.state === 'ok') ? _c('span', {
      staticClass: "status-pill status-pill--ok"
    }, [_vm._v("Gennemført")]) : _c('span', {
      staticClass: "status-pill status-pill--pending"
    }, [_vm._v("Afventer")])]), _vm._v(" "), (_vm.selectedTab !== 'queued') ? _c('td', {
      staticClass: "td-error"
    }, [(item.error && item.error.length > 0) ? _c('div', {
      staticClass: "message-list"
    }, _vm._l((item.error), function(err, idx) {
      return _c('span', {
        key: idx,
        class: {
          'message-error': err.StatusType === 'E',
          'message-warning': err.StatusType === 'W'
        }
      }, [_vm._v("\n                  " + _vm._s(err.MessageText) + "\n                ")])
    }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "td-action"
    }, [_c('div', {
      staticClass: "td-action__buttons"
    }, [(_vm.isOpusAbsenceActivated && item.employment_id) ? _c('button', {
      staticClass: "do-bttn do-bttn--small",
      attrs: {
        "disabled": !_vm.isOpusEmployment(item.employment),
        "title": _vm.isOpusEmployment(item.employment) ? 'Se personens fravær, som det er registreret i KMD Opus' : 'Ansættelsen er ikke en Opus-ansættelse'
      },
      on: {
        "click": function($event) {
          return _vm.openKmdAbsence(item)
        }
      }
    }, [_c('span', [_vm._v("Se i Opus")])]) : _vm._e(), _vm._v(" "), (item.state === 'error') ? _c('button', {
      staticClass: "do-bttn do-bttn--small",
      class: {
        'do-bttn--loading': item.isRetrying
      },
      attrs: {
        "disabled": item.isRetrying
      },
      on: {
        "click": function($event) {
          return _vm.retrySend(item)
        }
      }
    }, [_c('span', [_vm._v("Send igen")])]) : _vm._e()])])])
  })], 2)])]], 2)], _vm._v(" "), (_vm.isShowCreateOpusAbsence) ? _c('CreateOpusAbsence', {
    attrs: {
      "schoolId": _vm.schoolId
    },
    on: {
      "created": function($event) {
        return _vm.onCreated($event)
      },
      "close": function($event) {
        return _vm.setIsShowCreateOpusAbsence(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowQuotasModal) ? _c('KmdQuotasModal', {
    on: {
      "close": function($event) {
        _vm.isShowQuotasModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.kmdAbsenceItem) ? _c('KmdOpusAbsenceModal', {
    attrs: {
      "employmentId": _vm.kmdAbsenceItem.employment_id,
      "userName": String(_vm.kmdAbsenceItem.vUserName || ''),
      "employmentLabel": String(_vm.kmdAbsenceItem.vEmploymentNumber || ''),
      "transfer": _vm.kmdAbsenceItem,
      "absenceTypeCode": _vm.getAbsenceTypeCode(_vm.kmdAbsenceItem.kmd_absence_code_id)
    },
    on: {
      "close": function($event) {
        _vm.kmdAbsenceItem = null
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opus-absence-no-config"
  }, [_c('h2', [_c('i', [_vm._v("Skolens Opus-integration er ikke konfigureret korrekt. Kontakt Docendo for at få hjælp til opsætningen -\n          enten på chat eller email.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3600f47a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/KMD/OpusAbsence.vue
// module id = 1852
// module chunks = 1